import { createSlice } from '@reduxjs/toolkit';
import { BASE_END_POINT_JOB } from '../../../config';
import { getLocalStorageAuthentication } from '../../../lib/auth';

const initialState = {
  viewedProfile: null,
  viewedCandidate: null,
  viewedCandidatePhoto: null,
  loading: false,
  error: null
};

const candidateProfileViewSlice = createSlice({
  name: 'candidateProfileView',
  initialState,
  reducers: {
    fetchCandidateProfileViewRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCandidateProfileViewSuccess: (state, action) => {
      state.loading = false;
      state.viewedProfile = action.payload.profile;
      state.viewedCandidate = action.payload.candidate;
      state.viewedCandidatePhoto = action.payload.photo;
      state.error = null;
    },
    fetchCandidateProfileViewFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCandidateProfileView: (state) => {
      state.viewedProfile = null;
      state.viewedCandidate = null;
      state.viewedCandidatePhoto = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  fetchCandidateProfileViewRequest,
  fetchCandidateProfileViewSuccess,
  fetchCandidateProfileViewFailure,
  clearCandidateProfileView
} = candidateProfileViewSlice.actions;

// Thunk to fetch candidate profile view (profile + user info + photo)
export const fetchCandidateProfileView = (userId) => async (dispatch) => {
  console.log('👁️ [CandidateProfileView Thunk] Fetching profile for userId:', userId);
  
  dispatch(fetchCandidateProfileViewRequest());

  try {
    const localAuth = getLocalStorageAuthentication();
    if (!localAuth || !localAuth.token) {
      throw new Error('Not authenticated');
    }

    const headers = {
      'Authorization': `Bearer ${localAuth.token}`,
      'Content-Type': 'application/json'
    };

    // Fetch all data in parallel
    const [profileResponse, userResponse, photoResponse] = await Promise.all([
      // Fetch candidate profile
      fetch(`${BASE_END_POINT_JOB}/api/v1/candidate/profile/${userId}`, { headers }),
      // Fetch user info
      fetch(`${BASE_END_POINT_JOB}/api/v1/user/${userId}`, { headers }),
      // Fetch user photo
      fetch(`${BASE_END_POINT_JOB}/api/v1/file/user/${userId}`, { headers })
    ]);

    // Parse responses
    const profileData = await profileResponse.json();
    const userData = await userResponse.json();
    const photoData = await photoResponse.json();

    console.log('👁️ [CandidateProfileView Thunk] Profile response:', profileData);
    console.log('👁️ [CandidateProfileView Thunk] User response:', userData);
    console.log('👁️ [CandidateProfileView Thunk] Photo response:', photoData);

    // Check for errors
    if (!profileResponse.ok) {
      throw new Error('Failed to fetch candidate profile');
    }

    // Extract candidate info
    const candidate = userData.data || null;
    console.log('👁️ [CandidateProfileView Thunk] Extracted candidate:', candidate);

    // Extract photo URL
    let photoUrl = null;
    if (photoResponse.ok && photoData.data) {
      const fileData = Array.isArray(photoData.data) && photoData.data.length > 0
        ? photoData.data[0]
        : photoData.data;
      photoUrl = fileData?.publicUrl || null;
    }

    console.log('👁️ [CandidateProfileView Thunk] Photo URL:', photoUrl);

    // Dispatch success
    dispatch(fetchCandidateProfileViewSuccess({
      profile: profileData.data,
      candidate: candidate,
      photo: photoUrl
    }));

    console.log('✅ [CandidateProfileView Thunk] Successfully fetched profile view');
  } catch (error) {
    console.error('❌ [CandidateProfileView Thunk] Error:', error);
    dispatch(fetchCandidateProfileViewFailure(error.message));
  }
};

export default candidateProfileViewSlice.reducer;

